/* eslint-disable no-console */
import { AnyAction } from "redux"
import {
  INVOICE_FETCH_CALL,
  INVOICE_FETCH_FAILURE,
  INVOICE_FETCH_SUCCESS,
  SET_INVOICE,
  CLEAR_INVOICE,
  OPEN_MODAL,
  CLOSE_MODAL
} from "./invoice-types"

const INITIAL_STATE: App.InvoiceState = {
  modal: {
    type: "",
    state: false
  },
  listInvoices: {
    invoices: [
      {
        id: "",
        accountId: "",
        productName: "",
        cnpj: "",
        status: "",
        createdAt: ""
      }
    ],
    loading: false,
    totalItems: 0,
    error: ""
  },
  invoice: {
    id: "",
    accountId: "",
    productName: "",
    cnpj: "",
    status: "",
    createdAt: ""
  }
}

export default function invoiceReducer(state: App.InvoiceState = INITIAL_STATE, action: AnyAction) {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modal: {
          type: action.payload.type,
          state: true
        }
      }

    case CLOSE_MODAL:
      return {
        ...state,
        modal: {
          type: "",
          state: false
        }
      }

    case INVOICE_FETCH_CALL:
      console.log("type", action.type)

      return {
        ...state,
        listInvoices: {
          ...state.listInvoices,
          loading: true,
          error: ""
        }
      }

    case INVOICE_FETCH_SUCCESS:
      console.log("type", action)

      return {
        ...state,
        listInvoices: {
          ...state.listInvoices,
          loading: false,
          invoices: action.payload.data.invoices as App.InvoiceState["listInvoices"]["invoices"],
          totalItems: action.payload.data.totalItems
        }
      }

    case INVOICE_FETCH_FAILURE:
      console.log("type", action.type)

      return {
        ...state,
        listInvoices: {
          ...state.listInvoices,
          loading: false,
          error: action.payload
        }
      }

    case SET_INVOICE:
      return {
        ...state,
        invoice: action.payload
      }

    case CLEAR_INVOICE:
      return {
        ...state,
        invoice: INITIAL_STATE.invoice
      }

    default:
      console.log("type default", action.type)

      return state
  }
}
